export const datetimeFormats = {
  'en': {
    // short: {
    //   year: 'numeric', month: 'short', day: 'numeric'
    // },
    // long: {
    //   year: 'numeric', month: 'short', day: 'numeric',
    //   weekday: 'short', hour: 'numeric', minute: 'numeric'
    // }
      compact: {
        month: 'short',
        year: 'numeric',
        day: 'numeric',
      },
      readable: {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      },
      detailed: {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      }
  },
  'it': {
    // short: {
    //   day: 'numeric', month: 'short', year: 'numeric', 
    // },
    // long: {
    //   weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', 
    //   hour: 'numeric', minute: 'numeric'
    // }
      compact: {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      },

      readable: {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      },

      detailed: {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      }
  }
}